import * as runtime from '@/api/runtime'
import {
  BatchMarcFileUploadResponse,
  BatchMarcFileUploadResponseFromJSON
} from '@/api/models/batch/BatchMarcFileUploadResponse'
import { HTTPHeaders } from '@/api/runtime'

export interface UploadMarcFileRequest {
  data: FormData
}

export class BatchMarcRegFileUploadApi extends runtime.BaseAPI {
  async upload(
    requestParameters: UploadMarcFileRequest
  ): Promise<BatchMarcFileUploadResponse> {
    const headerParameters: HTTPHeaders = {}
    const response = await this.request({
      path: `/batch/bibliography/marc-upload`,
      method: 'POST',
      headers: headerParameters,
      body: requestParameters.data
    })

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchMarcFileUploadResponseFromJSON(jsonValue)
    ).value()
  }
}
